var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.725 7.37482H8.91132V6.42969H18.6701V12.4931L8.67786 12.4931V16.7983H16.6359V17.7434H7.73273V11.548L17.725 11.5479V7.37482Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2338 17.255L16.9612 15.0493L17.6195 14.3711L20.6159 17.2794L17.6074 20.0003L16.9734 19.2994L19.2338 17.255Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40211 5.94513C6.87359 5.94513 6.44513 6.37359 6.44513 6.90211C6.44513 7.43064 6.87359 7.8591 7.40211 7.8591C7.93064 7.8591 8.3591 7.43064 8.3591 6.90211C8.3591 6.37359 7.93064 5.94513 7.40211 5.94513ZM5.5 6.90211C5.5 5.85161 6.35161 5 7.40211 5C8.45262 5 9.30423 5.85161 9.30423 6.90211C9.30423 7.95262 8.45262 8.80423 7.40211 8.80423C6.35161 8.80423 5.5 7.95262 5.5 6.90211Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationWhite);
export default __webpack_public_path__ + "static/media/navigation-white.20eaec21857b812da9f464378b088081.svg";
export { ForwardRef as ReactComponent };